/**
 * An option to indicate which results are to be reported
 */
export enum FdReportResultsOption {
  RelativeCompactionAndAirVoids = 'RelativeCompactionAndAirVoids',
  RelativeCompactionOnly = 'RelativeCompactionOnly',
  AirVoidsOnly = 'AirVoidsOnly',
}

/**
 * An option to indicate if the sand bulk density check was carried out
 */
export enum SandBulkDensityCheck {
  None = 'None',
  Check = 'Check',
}
